export enum PlacementTypeVariant
{
    // None = 'None',
    // Employer = 'Employer',
    // Branch = 'Branch'
    None = 0,
    Employer = 1,
    Branch = 2
}
